import Api from './Api'

const END_POINT = 'brands'

export default {
    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(brand) {
        return await Api.post(`${END_POINT}`, brand)
    },
    async update(brand) {
        return await Api.patch(`${END_POINT}/${brand.id}`, brand)
    },
    async change_status(brand) {
        return await Api.patch(`${END_POINT}/${brand.id}/change-status`, brand)
    },
    async delete(brand) {
        return await Api.delete(`${END_POINT}/${brand.id}`, brand)
    }
}